export default {
  geofence: {
    action: {
      show: {
        tooltipShow: {
          notes: 'Tooltip for action to show geofence',
          message: 'Show geofence',
        },
        tooltipHide: {
          notes: 'Tooltip for action to hide geofence',
          message: 'Hide geofence',
        },
        disabledTooltip: {
          notes: 'Tooltip for action to toggle geofence when its disabled.',
          message: 'Geofence disabled for equipment. Enable it first!',
        },
      },
      edit: {
        tooltip: {
          notes: 'Tooltip for action to edit geofence',
          message: 'Edit geofence',
        },
      },
    },
  },
};
